import { useTranslation } from 'react-i18next';
import type { SettingsParamsType } from '@econtractor/types';
import ParamSwitch from '../ParamSwitch';

type WarehouseTabProps = {
    params: SettingsParamsType;
    isSaving: boolean;
    setParam: <K extends keyof SettingsParamsType>(key: K, value: SettingsParamsType[K]) => void;
};

const WarehouseTab = ({ params, isSaving, setParam }: WarehouseTabProps) => {
    const { t } = useTranslation(['Settings']);

    return (
        <div className="main-settings-fields">
            <ParamSwitch
                id="param-ignoreWarehousePrice"
                label={t('mainParams.fields.ignoreWarehousePrice.label')}
                description={t('mainParams.fields.ignoreWarehousePrice.description')}
                checked={params.ignoreWarehousePrice}
                disabled={isSaving}
                onChange={(v) => setParam('ignoreWarehousePrice', v)}
            />
            <div className="border-top">
                <ParamSwitch
                    id="param-objectReservationWarehouses"
                    label={t('mainParams.fields.objectReservationWarehouses.label')}
                    description={t('mainParams.fields.objectReservationWarehouses.description')}
                    checked={params.objectReservationWarehouses}
                    disabled={isSaving}
                    onChange={(v) => setParam('objectReservationWarehouses', v)}
                />
            </div>
            <div className="border-top">
                <ParamSwitch
                    id="param-customWarehouses"
                    label={t('mainParams.fields.customWarehouses.label')}
                    description={t('mainParams.fields.customWarehouses.description')}
                    checked={params.customWarehouses}
                    disabled={isSaving}
                    onChange={(v) => setParam('customWarehouses', v)}
                />
            </div>
            <div className="border-top">
                <ParamSwitch
                    id="param-confirmTeamWarehouseIncome"
                    label={t('mainParams.fields.confirmTeamWarehouseIncome.label')}
                    description={t('mainParams.fields.confirmTeamWarehouseIncome.description')}
                    checked={params.confirmTeamWarehouseIncome}
                    disabled={isSaving}
                    onChange={(v) => setParam('confirmTeamWarehouseIncome', v)}
                />
            </div>
            <div className="border-top">
                <ParamSwitch
                    id="param-creditControl"
                    label={t('mainParams.fields.creditControl.label')}
                    description={t('mainParams.fields.creditControl.description')}
                    checked={params.creditControl}
                    disabled={isSaving}
                    onChange={(v) => setParam('creditControl', v)}
                />
            </div>
        </div>
    );
};

export default WarehouseTab;
